var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironmentalDesign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f3a09ec1-4a2d-4dc4-94e1-a0cb25b8f955",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.4,
    height: 66.7,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 62.4 66.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-e3b69efc-623a-4fa4-9f95-88129b89a7d1{fill:url(#uuid-1390949d-00ff-4486-8957-f2a8483fe0cb);}.uuid-e3b69efc-623a-4fa4-9f95-88129b89a7d1,.uuid-1bbfd5a6-05cd-4f7c-8efe-386905c22012{fill-rule:evenodd;}.uuid-1bbfd5a6-05cd-4f7c-8efe-386905c22012{fill:url(#uuid-e9a0e24a-b394-43f2-a75f-da30b20a8cb0);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e9a0e24a-b394-43f2-a75f-da30b20a8cb0",
    x1: 13.6,
    y1: 41,
    x2: 49.2,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab73d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1390949d-00ff-4486-8957-f2a8483fe0cb",
    x1: 0,
    y1: 18.3,
    x2: 62.4,
    y2: 18.3,
    xlinkHref: "#uuid-e9a0e24a-b394-43f2-a75f-da30b20a8cb0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-554d62cb-3321-4c36-8ad7-7969215680ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-1bbfd5a6-05cd-4f7c-8efe-386905c22012",
    d: "M31.9,15.8c-.2-.5-.6-.5-.7-.5h0c-.1,0-.6,0-.7.5-3.6,9.7-12.8,24.1-16.5,29.9l-.2.3c-.2.2-.2.5,0,.7l4.6,11.6h-3.3c-.4,0-.8.3-.8.8v6.9c0,.4.3.8.8.8h32.4c.4,0,.8-.3.8-.8v-6.9c0-.4-.3-.8-.8-.8h-3.3l4.6-11.6c0-.2,0-.5,0-.7h0s.6-.4.6-.4h0l-.6.4c-1.3-1.9-12.5-19-16.7-30.2ZM31.2,43.9c1.6,0,2.9,1.3,2.9,2.9,0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9,1.3-2.9,2.9-2.9ZM46.6,59.9v5.3H15.8v-5.3h30.8ZM42.4,58.3h-22.5l-4.7-11.8.2-.3c2.6-4,9.3-14.3,13.7-23.6l1.3-2.6v22.3s-.5.1-.5.1c-1.9.5-3.2,2.3-3.2,4.2s2,4.4,4.4,4.4,4.4-2,4.4-4.4-1.3-3.7-3.2-4.2h-.5v-22.5l1.3,2.6c4.7,9.6,11.7,20.5,13.7,23.6l.2.3-4.7,11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e3b69efc-623a-4fa4-9f95-88129b89a7d1",
    d: "M52.4,36.6h7.7c.4,0,.8-.3.8-.8v-7.7c0-.4-.3-.8-.8-.8h-3.2v-.5c-3-10.9-11.5-17-18.2-20.2l-2.6-1.3h17v3.1c0,.4.3.8.8.8h7.7c.4,0,.8-.3.8-.8V.8c0-.4-.3-.8-.8-.8h-7.7c-.4,0-.8.3-.8.8v3.1h-17.3V.8c0-.4-.3-.8-.8-.8h-7.7c-.4,0-.8.3-.8.8v3.1H9.2V.8c0-.4-.3-.8-.8-.8H.8c-.4,0-.8.3-.8.8v7.7c0,.4.3.8.8.8h7.7c.4,0,.8-.3.8-.8v-3.1h17l-2.6,1.3c-6.7,3.2-15.2,9.4-18,20.2v.5h-3.3c-.4,0-.8.3-.8.8v7.7c0,.4.3.8.8.8h7.7c.4,0,.8-.3.8-.8v-7.7c0-.4-.3-.8-.8-.8h-2.9l.3-.9c3-10.2,11.3-15.9,17.9-18.9l.5-.2,2.4-1V1.5h6.1v6.1h-6.1v-1.3l-1.6.7v1.4c0,.4.3.8.8.8h7.7c.4,0,.8-.3.8-.8v-1.4l.9.4c6.7,3,15.2,8.7,18.3,19.1l.3.9h-2.9c-.4,0-.8.3-.8.8v7.7c0,.4.3.8.8.8ZM54.7,1.5h6.1v6.1h-6.1V1.5ZM7.7,7.7H1.6V1.5h6.1v6.1ZM9.1,28.9v6.1H3v-6.1h6.1ZM53.2,28.9h6.1v6.1h-6.1v-6.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentalDesign);
export default __webpack_public_path__ + "static/media/Environmental Design.4aa1139015ddac34a5297d983381002d.svg";
export { ForwardRef as ReactComponent };